import { useLocation } from 'react-router-dom'
import { useAuth } from '../AuthProvider'
import { useFixturesFromQuery } from '../fixtures'
import { greetingSubtitle, greetingTitle } from '../greeting'
import { useWorkspaceAccount } from '../WorkspaceAccountProvider'

type PageMeta = {
  title: string
  subtitle: string
}

function pageMeta(pathname: string): PageMeta {
  if (pathname.startsWith('/app/accounts')) {
    return {
      title: 'Trading Accounts',
      subtitle: 'Account Center — Live and Demo MetaTrader 5.',
    }
  }
  if (pathname.startsWith('/app/deposits')) {
    return {
      title: 'Deposit Funds',
      subtitle: 'Fund your Live trading account.',
    }
  }
  if (pathname.startsWith('/app/withdrawals')) {
    return {
      title: 'Withdraw Funds',
      subtitle: 'Request a withdrawal from your Live account.',
    }
  }
  if (pathname.startsWith('/app/trading-history')) {
    return {
      title: 'Trading History',
      subtitle: 'Closed trades and account activity.',
    }
  }
  if (pathname.startsWith('/app/transactions')) {
    return {
      title: 'Transactions',
      subtitle: 'Deposits, withdrawals, refunds and adjustments.',
    }
  }
  if (pathname.startsWith('/app/profile')) {
    return {
      title: 'Profile',
      subtitle: 'Identity and session controls.',
    }
  }
  if (pathname.startsWith('/app/support')) {
    return {
      title: 'Support',
      subtitle: 'Get help from Perfect Predict.',
    }
  }
  if (pathname.startsWith('/app/more')) {
    return {
      title: 'More',
      subtitle: 'Additional portal options.',
    }
  }
  return { title: '', subtitle: '' }
}

export function PageTitle() {
  const location = useLocation()
  const fixtures = useFixturesFromQuery()
  const { client } = useAuth()
  const ws = useWorkspaceAccount()
  const path = location.pathname.replace(/\/+$/, '') || '/'
  const isDashboard = path === '/app'

  const firstName = fixtures
    ? 'Alex'
    : (client?.firstName || '').trim() || (client?.email || '').split('@')[0] || ''

  if (isDashboard) {
    return (
      <header className="cp-page__head cp-page-title cp-page-title--dash">
        <div>
          <h1>{greetingTitle(firstName)}</h1>
          <p className="cp-page__sub">{greetingSubtitle(ws.hasLiveAccount)}</p>
        </div>
      </header>
    )
  }

  const meta = pageMeta(location.pathname)
  return (
    <header className="cp-page__head cp-page-title">
      <div>
        <h1>{meta.title}</h1>
        <p className="cp-page__sub">{meta.subtitle}</p>
      </div>
    </header>
  )
}
